/**
 * RC VALIDATOR
 * Sistema de validación simple basado en atributos HTML.
 * Requisitos:
 * 1. Los inputs deben tener el atributo 'required' si son obligatorios.
 * 2. Opcional: Atributo 'data-name="Nombre del Campo"' para mensajes personalizados.
 * 3. Opcional: Atributo 'type="email"' o 'type="number"' para validaciones específicas.
 */

class RcValidator {
    constructor(options = {}) {
        this.popupId = options.popupId || 'rc-error-popup';
        this.titleId = options.titleId || 'rc-error-title';
        this.msgId = options.msgId || 'rc-error-msg';
        this.primaryColor = options.primaryColor || '#000000';
    }

    /**
     * Valida todos los inputs dentro de un contenedor (Paso)
     * @param {HTMLElement|string} container - El elemento DOM o su ID
     * @returns {boolean} - true si todo está bien, false si hay errores
     */
    validate(container) {
        const step = typeof container === 'string' ? document.getElementById(container) : container;
        if (!step) return true;

        // 1. Buscar inputs requeridos visibles
        const inputs = step.querySelectorAll('input[required], select[required], textarea[required]');
        
        for (let input of inputs) {
            // Ignorar inputs ocultos (por si acaso)
            if (input.offsetParent === null) continue;

            // a) Validar vacío (Checkboxes vs Valor)
            if (input.type === 'checkbox' || input.type === 'radio') {
                if (!input.checked) {
                    this.triggerError(input, 'Debes marcar esta casilla para continuar.');
                    return false;
                }
            } else {
                if (!input.value.trim()) {
                    this.triggerError(input, 'Este campo está vacío.');
                    return false;
                }
            }

            // b) Validar Email
            if (input.type === 'email') {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(input.value.trim())) {
                    this.triggerError(input, 'El formato del email no es correcto.');
                    return false;
                }
            }

            // c) Validar Número (mínimos y máximos)
            if (input.type === 'number') {
                const val = parseFloat(input.value);
                const min = parseFloat(input.getAttribute('min'));
                const max = parseFloat(input.getAttribute('max'));

                if (isNaN(val)) {
                    this.triggerError(input, 'Debes introducir un número válido.');
                    return false;
                }
                if (!isNaN(min) && val < min) {
                    this.triggerError(input, `El valor debe ser mayor o igual a ${min}.`);
                    return false;
                }
                if (!isNaN(max) && val > max) {
                    this.triggerError(input, `El valor debe ser menor o igual a ${max}.`);
                    return false;
                }
            }
        }

        return true; // Todo correcto
    }

    /**
     * Muestra el Popup de error
     */
    triggerError(input, hint) {
        const fieldName = input.getAttribute('data-name') || 'Campo desconocido';
        const popup = document.getElementById(this.popupId);
        
        if (popup) {
            document.getElementById(this.titleId).innerText = `Revisa: ${fieldName}`;
            document.getElementById(this.msgId).innerText = hint;
            
            popup.classList.add('active');
            
            // Auto-focus al input fallido al cerrar (opcional)
            input.focus(); 
            input.classList.add('rc-input-error-shake'); // Clase para animar input
            setTimeout(() => input.classList.remove('rc-input-error-shake'), 500);
        } else {
            // Fallback por si no existe el HTML del popup
            alert(`${fieldName}: ${hint}`);
        }
    }

    closePopup() {
        const popup = document.getElementById(this.popupId);
        if (popup) popup.classList.remove('active');
    }
}